import React from "react";
import { LanguageContext } from "../common/language";
import { DocumentReference } from "@atgof-firebase/firebase";
import {
  ExportButton,
  ExportButtonAction,
  pdfExportPhrases,
} from "./ExportButton";
import { ProjectContext } from "../data/projectContext";

export function ScriptExportButton({
  sceneRef,
  showTramlines,
}: {
  sceneRef: DocumentReference | undefined;
  showTramlines: boolean;
}) {
  const { language } = React.useContext(LanguageContext);
  const { categories } = React.useContext(ProjectContext);
  const isAdmin = categories.includes("admin");
  const isPostProduction = categories.includes("postProduction");
  const actions = React.useMemo(() => {
    const exportData = {
      scene: sceneRef,
      parameters: {
        lang: language,
        showTramlines,
      },
    };
    let res: ExportButtonAction[] = [];
    if (isAdmin)
      res.push({
        kind: "callSheetSceneScript",
        exportData,
        phrases: pdfExportPhrases,
      });
    if (isPostProduction)
      res.push({
        kind: "postProductionScene",
        exportData,
        phrases: {
          ...pdfExportPhrases,
          generate: isAdmin ? "generate-postProduction-pdf" : "generate-pdf",
        },
      });
    return res;
  }, [isAdmin, isPostProduction, sceneRef?.path, language, showTramlines]);
  if (!sceneRef) return null;
  return <ExportButton actions={actions} />;
}
